<template>
    <lb-drawer :value="value" @input="$emit('input', $event)" heading="Task Details" width="600" :loading="loading" data-testid="financialclose-project-trialbalance__selectedtaskdrawer">
        <template v-slot:body>
            <!-- Skeleton Loader -->
            <div v-if="loading" class="pa-4">
                <v-skeleton-loader type="chip, chip, chip" class="mb-4" />
                <v-skeleton-loader type="heading" class="mb-3" />
                <v-skeleton-loader type="list-item-two-line" class="mb-2" />
                <v-skeleton-loader type="list-item-two-line" class="mb-2" />
                <v-skeleton-loader type="list-item-two-line" class="mb-2" />
                <v-skeleton-loader type="list-item-two-line" class="mb-4" />
                <v-row class="px-3">
                    <v-col cols="3" v-for="n in 4" :key="n" class="pa-1">
                        <v-skeleton-loader type="card" height="70" />
                    </v-col>
                </v-row>
                <v-skeleton-loader type="divider" class="my-4" />
                <v-skeleton-loader type="paragraph" />
            </div>

            <!-- Task Detail Content -->
            <div v-else-if="task">
                <v-row data-testid="financialclose-project-trialbalance__selectedtaskdrawer-row">
                    <v-col cols="2" class="d-flex align-center justify-start font-weight-bold text-font-size-md">
                        <span data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-linkedtask">Linked Task</span>
                    </v-col>
                    <v-col cols="10" class="d-flex">
                        <div class="border-on py-1 radius-small" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-linkedtasklist">
                            <v-chip
                                v-for="(item, index) in linkedTasks"
                                :key="index"
                                label
                                :color="task._id === item._id ? 'caccounting' : 'white'"
                                :class="`pa-1 px-2 mx-1 ${(task._id === item._id) ? 'white--text' : ''}`"
                                @click="$emit('select-task', item)"
                                data-testid="financialclose-project-trialbalance__selectedtaskdrawer-linkedtask-chip"
                            >
                                <span data-testid="financialclose-project-trialbalance__selectedtaskdrawer-linkedtask-chip-label">{{ item.ref }}</span>
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>
                <v-row data-testid="financialclose-project-trialbalance__selectedtaskdrawer-details-row">
                    <v-col class="px-2 font-weight-bold text-font-size-md" cols="12" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-description">{{ task.description }}</v-col>
                    <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-role">Role</v-col>
                    <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-role">
                        <v-chip label color="lightpurple" class="caccounting--text" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-role-chip">
                            <span data-testid="financialclose-project-trialbalance__selectedtaskdrawer-role-chip-label">{{ userRole }}</span>
                        </v-chip>
                    </v-col>
                    <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-status">Status</v-col>
                    <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-status">{{ task.stage }}</v-col>
                    <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-due">Due</v-col>
                    <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-due">{{ $nova.formatDate(task.duedate) }}</v-col>
                    <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-location">{{ $store.state.LocationHeader || 'Location' }}</v-col>
                    <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-location">{{ locationName }}</v-col>

                    <v-slide-y-transition>
                        <v-row class="px-3 py-2" v-if="showMore" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-more-row">
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-priority">Priority</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-priority">{{ task.priority }}</v-col>
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-category">Category</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-category">{{ task.category }}</v-col>
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-subcategory">Sub Category</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-subcategory">{{ task.subcategory }}</v-col>
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-assertions">Assertions</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-assertions">{{ task.assertions }}</v-col>
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-purpose">Purpose</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-purpose">{{ task.purpose }}</v-col>
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-instruction">Instruction</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-instruction">{{ task.instruction }}</v-col>
                            <v-col cols="3" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-tags">Tags</v-col>
                            <v-col cols="9" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-value-tags">{{ task.tags }}</v-col>
                        </v-row>
                    </v-slide-y-transition>
                    <v-col cols="12">
                        <v-btn @click="showMore = !showMore" color="white" class="px-0" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-more-btn">
                            <v-icon>{{ showMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            <p class="ma-0 pa-0 text-button px-1 black--text" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-more-btn-label">
                                {{ showMore ? 'Hide items' : '7 more items' }}
                            </p>
                        </v-btn>
                    </v-col>
                    <v-col cols="3" class="pa-1">
                        <v-card class="d-flex radius-small shadow-off total_task_tab tb_tab_border flex-column align-start justify-center pa-2" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-trialbalance">
                            <v-card-title class="font-size-xm pb-3 pa-0" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-trialbalance-title">Trial Balance</v-card-title>
                            <span class="text-font-size-md black--text" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-trialbalance-value">
                                {{ $nova.formatNumber(Number(trialBalanceTotal || 0).toFixed(0)) }}
                            </span>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="pa-1">
                        <v-card class="d-flex radius-small shadow-off total_task_tab tb_tab_border flex-column align-start justify-center pa-2" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-schedulebalance">
                            <v-card-title class="font-size-xm all-width pb-3 pa-0 d-flex align-center justify-space-between" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-schedulebalance-title">
                                Schedule Balance
                                <v-icon size="6">mdi-information</v-icon>
                            </v-card-title>
                            <span class="text-font-size-md black--text" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-schedulebalance-value">
                                {{ $nova.formatNumber((Number((task.result || {}).value?.total_value) || 0).toFixed(0)) }}
                            </span>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="pa-1">
                        <v-card class="d-flex radius-small shadow-off flex-column error-tab align-start justify-center pa-2" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-difference">
                            <v-card-title class="font-size-xm all-width pb-3 pa-0 d-flex align-center justify-space-between" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-difference-title">
                                Difference
                                <v-icon>mdi-information</v-icon>
                            </v-card-title>
                            <span class="text-font-size-md red--text" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-difference-value">
                                {{ $nova.formatNumber((((task.__tbtotals || {}).total || 0) - (Number((task.result || {}).value?.total_value) || 0)).toFixed(0)) }}
                            </span>
                        </v-card>
                    </v-col>
                    <v-col cols="3" class="pa-1">
                        <v-card class="d-flex radius-small shadow-off total_task_tab tb_tab_border flex-column align-start justify-center pa-2" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-threshold">
                            <v-card-title class="font-size-xm pb-3 pa-0" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-threshold-title">Threshold</v-card-title>
                            <span class="text-font-size-md black--text" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-card-threshold-value">
                                {{ task.threshold ? task.threshold : 'NA' }}
                            </span>
                        </v-card>
                    </v-col>
                    <v-col cols="6">
                        <p class="ma-0 mb-1" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-preparer">Preparer</p>
                        <div class="d-flex px-1" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-preparer-list">
                            <div v-for="(preparer, index) in task.preparer" :key="index" class="avatars-group__item d-flex" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-preparer-item">
                                <v-tooltip top content-class="tooltip-top">
                                    <template v-slot:activator="{ on }" v-if="preparer">
                                        <v-avatar v-on="on" size="25" color="caccounting" class="white--text font-small d-flex pa-0 avatar-white-border ma-0 v-avatar" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-preparer-avatar">
                                            {{ getNameById(preparer)[0] }}
                                        </v-avatar>
                                    </template>
                                    <span data-testid="financialclose-project-trialbalance__selectedtaskdrawer-preparer-name">{{ getNameById(preparer) }}</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <p class="ma-0 mb-1" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-label-approver">Approver</p>
                        <div class="d-flex px-1" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-approver-list">
                            <div v-for="(approver, index) in task.approver" :key="index" class="avatars-group__item d-flex" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-approver-item">
                                <v-tooltip top content-class="tooltip-top" v-if="approver">
                                    <template v-slot:activator="{ on }">
                                        <v-avatar v-on="on" size="25" color="caccounting" class="white--text font-small d-flex pa-0 avatar-white-border ma-0 v-avatar" data-testid="financialclose-project-trialbalance__selectedtaskdrawer-approver-avatar">
                                            {{ getNameById(approver)[0] }}
                                        </v-avatar>
                                    </template>
                                    <span data-testid="financialclose-project-trialbalance__selectedtaskdrawer-approver-name">{{ getNameById(approver) }}</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </template>
    </lb-drawer>
</template>

<script>
export default {
    name: 'TaskDetailDrawer',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        task: {
            type: Object,
            default: () => null,
        },
        linkedTasks: {
            type: Array,
            default: () => [],
        },
        userNameList: {
            type: Array,
            default: () => [],
        },
        userid: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showMore: false,
        };
    },
    computed: {
        locationName() {
            return this.task?.__computed?.locationName || this.task?.locationName || this.task?.location || '';
        },
        trialBalanceTotal() {
            return this.task?.__computed?.tbtotals?.total ?? this.task?.__tbtotals?.total ?? 0;
        },
        userRole() {
            if (!this.task) return '';
            if ((this.task.preparer || []).includes(this.userid)) return 'Preparer';
            if ((this.task.approver || []).includes(this.userid)) return 'Approver';
            return '';
        },
    },
    methods: {
        getNameById(id) {
            const user = this.userNameList.find((name) => name._id === id);
            return user ? user.name : '';
        },
    },
    watch: {
        value(val) {
            if (!val) {
                this.showMore = false;
            }
        },
    },
};
</script>
